/* eslint-disable import/no-unassigned-import */
require('./globals')

if (__DEV__)
  require('./development')

require('./mount')
